import {AppConfig} from "../AppConfig";
import Util from "@/Master/Util";
const config:AppConfig = {
    productId: 70052,
    releaseProductId: 70052,
    ia_host: "us.5252slot.com",
    adjust_app_token: "u33yl2b66u4g",
    adjust_event_token: "adnp6l",
    privacy_url: "https://evolvegrouplimited.com/privacy.html",
    trems_url: "https://evolvegrouplimited.com/terms.html",
    sweepstakes_rules_url: "https://evolvegrouplimited.com/clover/sweepsrules.html",
    responsible_play_url: "https://evolvegrouplimited.com/clover/responsible.html",
    game_statement: "https://evolvegrouplimited.com/clover/gamestatement.html",
    mail: "playsshn31@gmail.com",
    game_event_token_config: "purchase_complete,xolfrr|first_purchase,18gd6s",
    game_api_url: "https://wet.5252slot.com",
    nat_host: "wet.5252slot.com",
    forterId: "cb5e5213f895",
    h5_version_code: 1,
    h5_version_name: '1',
    h5_app_name: '80052',
    h5_package_name: "goldcasinofun.com",
    h5_host_name: Util.isWindow ? window.location.host : '',

    h5_mode: 1,//0默认PWA模式 1直接进入游戏模式
    h5_res_host: "https://remars.goldcasinofun.com/GoldenCloverSimpleH5/",
    h5_res_ver: "webgl/version_8/",

    productVersion: '_PWA_VERSION_',//动态生成的版本号
    adjust_environment: "production",//production 或 sandbox
    adjust_logLevel: "none",
    GTM_ID: "GTM-TFV85SMP",
    feiShuApi: "",

    sm_businessId: "h5_vxozpcpsms",
    sm_apiKey: "un8tx6z8hxm5wetsl8rvfy23t9vvrj4ah2b4",
};

export default config; // 确保有默认导出
